export default __webpack_public_path__ + "static/media/key.935c9d53.svg";